import { render, staticRenderFns } from "./DdUriageDayByDayDisp.vue?vue&type=template&id=38be76a4&scoped=true&"
import script from "./DdUriageDayByDayDisp.vue?vue&type=script&lang=js&"
export * from "./DdUriageDayByDayDisp.vue?vue&type=script&lang=js&"
import style0 from "./DdUriageDayByDayDisp.vue?vue&type=style&index=0&id=38be76a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be76a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VDatePicker,VIcon,VMenu,VProgressLinear,VRow,VSpacer})
